"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
function mapToColumnBlockProps({ data, mappers, inHero, packages, forms, sectionKey, }) {
    let image = null;
    if (data.image?.length) {
        image = mappers.mapBlock({
            block: data.image?.[0],
            mappers,
            inHero,
        });
    }
    let backgroundImage = null;
    if (data.backgroundImage?.length) {
        backgroundImage = mappers.mapBlock({
            block: data.backgroundImage?.[0],
            mappers,
            inHero,
        });
    }
    let listIcon = null;
    if (data.listIcon?.length) {
        listIcon = mappers.mapBlock({
            block: data.listIcon?.[0],
            mappers,
            inHero,
        });
    }
    return {
        cardStyled: true,
        image,
        svg: image?.props.isSvg,
        backgroundImage,
        listIcon,
        backgroundColor: data?.backgroundColor?.toLowerCase(),
        textColor: data?.textColor?.toLowerCase(),
        mobileTextColor: data?.mobileTextColor,
        borderType: data?.borderType?.toLowerCase(),
        borderColor: data?.borderColor?.toLowerCase(),
        children: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [data?.heading && (0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Typography, { variant: "h4", children: data.heading }), data?.subheading && ((0, jsx_runtime_1.jsx)(gatsby_theme_leshen_1.Typography, { variant: "h5", children: data.subheading })), data.mainContent &&
                    mappers.mapRichText({
                        richText: data.mainContent,
                        mappers,
                        packages,
                        forms,
                        listIcon: listIcon ?? undefined,
                        blockKey: data.id || undefined,
                        sectionKey,
                    })] })),
    };
}
exports.default = mapToColumnBlockProps;
